import { ApiMetric, ApiProjectType } from "@incendium/api";
import { useHasProjectType } from "features/project";
import { useMemo } from "react";

export function useIsEcommerceProject() {
  const hasProjectType = useHasProjectType();
  return useMemo(
    () => hasProjectType(ApiProjectType.TYPE_ECOMMERCE),
    [hasProjectType],
  );
}

/** Chart key variant so saved ecom configs don't leak into non-ecom views. */
export function dashboardChartKey(baseKey: string, isEcommerce: boolean) {
  return isEcommerce ? baseKey : `${baseKey}_non_ecom`;
}

export function withoutAddToCartMetrics(
  fields: ApiMetric[],
  isEcommerce: boolean,
): ApiMetric[] {
  if (isEcommerce) return fields;
  return fields.filter((field) => !String(field).includes("ADD_TO_CART"));
}

export function revenueOrConversions(
  isEcommerce: boolean,
): ApiMetric.METRIC_REVENUE | ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT {
  return isEcommerce
    ? ApiMetric.METRIC_REVENUE
    : ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT;
}
